import { ApiCreateCustomer, ApiDeleteCustomer, ApiGetCustomerById, ApiGetCustomerList, ApiUpdateCustomer } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function CustomerService() {
    const { showFail } = useModal()

    const { fetch: apiGetCustomerList } = useFetch(ApiGetCustomerList)
    const { fetch: apiDeleteCustomer } = useFetch(ApiDeleteCustomer)
    const { fetch: apiCreateCustomer } = useFetch(ApiCreateCustomer)
    const { fetch: apiUpdateCustomer } = useFetch(ApiUpdateCustomer)
    const { fetch: apiGetCustomerById } = useFetch(ApiGetCustomerById)

    const fetchCustomerList = async(customerName, status, pageSize, index) => {
        const res = await apiGetCustomerList({
            data: {
                customerName,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteCustomer = async(customerId, status) => {
        const res = await apiDeleteCustomer({
            data: {
                customerId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerById = async(customerId) => {
        const res = await apiGetCustomerById({
            data: {
                customerId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateCustomer = async(customerName, idNumber, address, phone, email, instagram, idPhotoFile) => {
        let data = new FormData()

        data.append('CustomerName', customerName)
        data.append('IdNumber', idNumber)
        data.append('Address', address)
        data.append('Phone', phone)
        data.append('Email', email)
        data.append('Instagram', instagram)
        data.append('Picture', idPhotoFile)

        const res = await apiCreateCustomer({ 
            data, 
            headers: {
                'Content-type': 'multipart/form-data'
            } 
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateCustomer = async(customerId, customerName, idNumber, address, phone, email, instagram, idPhotoFile) => {
        let data = new FormData()

        data.append('CustomerId', customerId)
        data.append('CustomerName', customerName)
        data.append('IdNumber', idNumber)
        data.append('Address', address)
        data.append('Phone', phone)
        data.append('Email', email)
        data.append('Instagram', instagram)
        data.append('Picture', idPhotoFile)

        const res =  await apiUpdateCustomer({ 
            data,
            headers: {
                'Content-type': 'multipart/form-data'
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchCustomerList,
        fetchDeleteCustomer,
        fetchCustomerById,
        fetchCreateCustomer,
        fetchUpdateCustomer
    }
}